module.exports = __webpack_public_path__ + "media/login-page-bg-rzd-1920@2x.9cf5170a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-page-bg-rzd-1920@2x.jpg
// module id = 1110
// module chunks = 62